export const infoItems=
 [
    {"id":1,
    "title":"OPTIMIZE YOUR PROCESSES!",
     "des":"You will get a free personal manager who will help to build a strategy, optimize the budget and deadline, organize the development process and launch the project.",
     "image":"https://f5-studio.com/wp-content/uploads/2019/12/why-icon-1.png"},

   {"id":2,
    "title":"ACCELERATE YOUR REVENUE!",
    "des":"200+ years of cumulative team experience. No matter the industry, business goals, or location to turn your requirements into the profitable solution.",
      "image":"https://f5-studio.com/wp-content/uploads/2019/12/why-icon-3.png"},

{"id":3,
"title":"PROTECT YOUR BUSINESS!",
"des":"Every website or app is secure and built on the latest versions of open source content",
"image":"https://f5-studio.com/wp-content/uploads/2020/05/protect-your-business.png"},

{"id":4,
    "title":"GET YOUR LEADS GENERATION STRATEGY!",
    "des":"Combining marketing and technology, we provide a full range of services from the UI/UX design and web development to SEO and promotion.",
     "image":"https://f5-studio.com/wp-content/uploads/2019/12/why-icon-2.png"},

{"id":5,
    "title":"EXCEED YOUR EXPECTATIONS!",
    "des":"Not limited to standard methods. We use the horizontal a corporate culture that naturally encourages employees to be masters of innovations.",
      "image":"https://f5-studio.com/wp-content/uploads/2019/12/why-icon-4.png"},

{"id":6,
    "title":"RESPECT YOU!",
    "des":"It's great to work with honesty, transparency, trustworthy and law-abiding.",
     "image":"https://f5-studio.com/wp-content/uploads/2020/05/respect-you.png"}
    ]

    export const aboutInfos=
 [
    {id:"1",
    img:"https://i.ibb.co/Ssx3BdG/about-icon-1.png",
    bg:"#0393FE",
    title1:"We are creative",
     des1:"We are masters in innovative, agile creative approaches in producing websites.Our refreshing....",
     title2: "We are creative",
     des2:"We are masters in innovative, agile creative approaches in producing websites. Our refreshing way of working brings the best possible results for our clients. We deliver beautifully crafted projects with passion.",
    },

     {id:"2",
     img:"https://i.ibb.co/vYs3tmx/about-icon-2.png",
     bg:"#FF704E",
     title1:"We love our services",
      des1:"Our approach to the work process, from sketch to development, is focused on creating an unforgettable....",
      title2: "We love our services",
      des2:"Our approach to the work process,from sketch to development, is focused oncreating an unforgettable user impression.It’s true magic when the concept comes to lifin a pixel-perfect design and fully functional website.Take a look at our portfolio to see just a few recentprojects that we have worked on."
    },
 

      {id:"3",
      img:"https://i.ibb.co/qFC7PJT/about-icon-3.png",
      bg:"#8080FA",
      title1:"We use the latest technologies",
       des1:"We create highly-usable websites that are powered by an array of technologies and then....",
       title2: "We use the latest technologies",
       des2:"We create highly-usable websites that are powered by an array of technologies and then we analyze performance data to optimize and refine.",},
      
      {id:"4",
      img:"https://i.ibb.co/MSY0NG9/about-icon-4.png",
      bg:"#FC4A36",
      title1:"Best team",
       des1:"Our team provides personal, professional and friendly service which carefully considers....",
       title2: "Best team",
       des2:"Our team provides personal, professional and friendly service which carefully considers your business goals and requirements. We transform innovative visions into brilliant realities. Got one? Let’s make outstanding work together!.",
      }

    ]
    export const serviceProducts=
    [
      {
        id:"1",
        icon:"https://i.ibb.co/zmyYS7P/web.png",
        title:" WEB DEVELOPMENT",
        bg:"#8282FB",
      content:["Website development","corporate website","startup websites",
        "landing and promo sites","E-commerce","wordpress development","web apps developement","fixed price website"]
       },
       {
        id:"2",
        icon:"https://i.ibb.co/4mMz0MM/design.png",
        title:"DESIGN",
        bg: "#FF644E",
       content:["Web Design","UI", "UX design","Mobile app design","Logo Design","Brand Identity","Banner ad design"]
       },
       {
        id:"3",
        icon:"https://i.ibb.co/g96dHyw/seo.png",
        title:"SEO SERVICE",
        bg:"#286DEC",
      content:["Tech SEO","On-page SEO", "Off-page SEO","SEO copywriting"]
       },
       {
        id:"4",
        icon:"https://i.ibb.co/99FfzXZ/digital.png",
        title:"DIGITAL MARKETING",
        bg:"#5555D5",
      content:["Website marketing strategy","Content marketing","PPC services","social media marketing services"]
       },
       {
        id:"5",
        icon:"https://i.ibb.co/WgPq6pc/outsource.png",
        title:"OUTSOURCE",
        bg:"#FC4B36",
      content:["Dedicated team","Hire Front-End Developer","Hire Designer","Hire project manage"]
       }

    ]